/**
 * User Preferences API — Write a set-membership preference.
 *
 * POST /v1/user-preferences
 *
 * Owner-only: the subject school-user is resolved from the session + active
 * school context, never caller-supplied. `op: "add"` inserts the membership row
 * (idempotent), `op: "remove"` deletes it. The (namespace, key) pair is
 * validated against the shared-types registry; unknown namespaces / keys are
 * rejected (AE4).
 */

import { z } from 'zod'

import { UserPreferenceNamespaceSchema } from '../../schemas/entities/user-preference'

export const USER_PREFERENCE_WRITE_OPS = ['add', 'remove'] as const
export type UserPreferenceWriteOp = (typeof USER_PREFERENCE_WRITE_OPS)[number]

export const WriteUserPreferenceRequestSchema = z.object({
  namespace: UserPreferenceNamespaceSchema,
  key: z.string().min(1),
  op: z.enum(USER_PREFERENCE_WRITE_OPS)
})

export type WriteUserPreferenceRequest = z.infer<typeof WriteUserPreferenceRequestSchema>

export const WriteUserPreferenceResponseSchema = z.object({
  namespace: UserPreferenceNamespaceSchema,
  key: z.string(),
  op: z.enum(USER_PREFERENCE_WRITE_OPS)
})

export type WriteUserPreferenceResponse = z.infer<typeof WriteUserPreferenceResponseSchema>
